import React, { useEffect, useMemo, useState } from 'react';
import ClaimTabs from '../claimTabs/claimtabs';
import TabRouter from '../../routers/tabRouter';
import { BANK_DETAILS_TAB, SURVEY_TAB, TABS } from '../../utils/constants/tabs';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ClaimApplicationProjections } from '../../actions/claimApplication';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import { useTranslation } from 'react-i18next';

const ClaimTabArea = (props: {
    claimApplication: Partial<ClaimApplicationProjections>;
}): JSX.Element => {
    const { claimApplication } = props;
    let { path }: any = useParams();
    const { t, i18n } = useTranslation();
    const [activeTab, setActiveTab] = useState<string>(TABS.communication.key);
    const location = useLocation();
    const history = useHistory();

    // Derived from the untranslated TABS constants on every language change -
    // translating the previous output would just re-resolve an already
    // translated string and keep the stale wording.
    const activeTabs = useMemo(() => {
        let activeTabDisplayed = {
            ...TABS,
        } as any;
        let transformedTabs = {} as any;
        if (claimApplication.isBankDetailsVisible) {
            activeTabDisplayed = {
                ...activeTabDisplayed,
                BANK_DETAILS_TAB,
            };
        }
        if (claimApplication.isSurveyTabVisible) {
            activeTabDisplayed = {
                ...activeTabDisplayed,
                SURVEY_TAB,
            };
        }
        for (const key in activeTabDisplayed) {
            if (activeTabDisplayed.hasOwnProperty(key)) {
                transformedTabs[key] = {
                    ...activeTabDisplayed[key],
                    label: ` ${t(activeTabDisplayed[key].label)}`,
                };
            }
        }

        return transformedTabs;
    }, [
        claimApplication.isBankDetailsVisible,
        claimApplication.isSurveyTabVisible,
        i18n.language,
        t,
    ]);

    useEffect(() => {
        if (path !== '' && path !== undefined && path === 'claim-details') {
            setActiveTab(TABS.claimDetails.key);
        } else {
            setActiveTab(TABS.communication.key);
        }
    }, [path]);

    useEffect(() => {
        let query = new URLSearchParams(location.search) as any;
        if (
            (!GENERAL_FUNCTIONS.findActiveTabToClaimTabArea(query.get('tab')) ||
                !query.get('tab') ||
                (!claimApplication.isBankDetailsVisible &&
                    query.get('tab') === BANK_DETAILS_TAB.key) ||
                (!claimApplication.isSurveyTabVisible &&
                    query.get('tab') === SURVEY_TAB.key)) &&
            !path
        ) {
            history.replace({
                pathname: history.location.pathname,
                search:
                    '?' +
                    new URLSearchParams({ tab: 'claimDetails' }).toString(),
            });
        }
        setActiveTab(query.get('tab'));
    }, [location.search]);

    const handleTabClick = (tab: string) => {
        history.push({
            pathname: history.location.pathname,
            search: '?' + new URLSearchParams({ tab: tab }).toString(),
        });
    };
    return (
        <>
            <ClaimTabs
                activeTab={activeTab}
                handleTabClick={handleTabClick}
                navItems={activeTabs}
            />
            <TabRouter
                activeTab={activeTab}
                claimApplication={claimApplication}
            />
        </>
    );
};

export default ClaimTabArea;
